module.exports = "/images/vendor/desiigner-svg/svg/places/mask.svg?8a732eb93c1765478c83315f87c8445c";